<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tP42Fs/tc-custom/9781477306147.jpg?1718073969662" alt="This image is the cover for the book Origins of the American Indians, LLILAS Latin American Monograph Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Origins of the American Indians, LLILAS Latin American Monograph Series
      </h1>
      <p class="bookDescription body article font2">
        <b>An examination of early European theories about the origin of American indigenous peoples.</b><br/><br/>The American Indian—origin, culture, and language—engaged the best minds of Europe from 1492 to 1729. Were the Indians the result of a co-creation? Were they descended from the Ten Lost Tribes of Israel? Could they have emigrated from Carthage, Phoenicia, or Troy? All these and many other theories were proposed.<br/><br/>How could scholars account for the multiplicity of languages among the Indians, the differences in levels of culture? And how did the Indian arrive in America—by using as a bridge a now-lost continent or, as was later suggested by some persons in the light of an expanding knowledge of geography, by using the Bering Strait as a migratory route?<br/><br/>Most of the theories regarding the American Indian were first advanced in the sixteenth century. The two most influential men in an early-developing controversy over Indian origins were Joseph de Acosta and Gregorio García. Approaching the subject with restraint and with a critical eye, Acosta, in 1590, suggested that the presence of diverse animals in America indicated a land connection with the Old World. On the other hand, García accepted several theories as equally possible and presented each in the strongest possible light in his <i>Origen de los indios</i> of 1607.<br/><br/>In this distinctive book Lee E. Huddleston looks carefully into those theories and proposals. From many research sources he weaves an historical account that engages the reader from the very first.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lee Eldridge Huddleston
      </h2>
      
      <p class="authorDescription body article">Lee E. Huddleston (1935–2003) was Professor of History at the University of North Texas.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of Texas Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1bbb73d0